import { Component, Input, computed } from '@angular/core';

type SpinnerSize = 'sm' | 'md' | 'lg';

/**
 * Animated loading indicator shown while async operations are in progress.
 */
@Component({
  selector: 'es-spinner',
  template: `
    <div [class]="classes()" role="status">
      <span class="animate-spin inline-block border-2 border-current border-t-transparent rounded-full" [class]="spinnerSize()"></span>
      @if (label) {
        <span class="text-[var(--text-secondary)]">{{ label }}</span>
      }
    </div>
  `,
})
export class SpinnerComponent {
  @Input() size: SpinnerSize = 'md';
  @Input() label?: string;

  classes = computed(() => 'inline-flex items-center gap-2');
  spinnerSize = computed(() => {
    const sizes: Record<SpinnerSize, string> = {
      sm: 'w-3 h-3',
      md: 'w-5 h-5',
      lg: 'w-8 h-8',
    };
    return sizes[this.size];
  });
}
